import { Box, Typography } from "@mui/material";
import { Spacing } from "Infrastructure/Themes/Themes";

type Props = {
  title?: string | null;
  description?: string | null;
};

export const QuestionnaireSectionHeader = ({ title, description }: Props) => (
  <Box pb={Spacing.M} borderBottom={1} borderColor="divider" sx={{ breakAfter: "avoid", breakInside: "avoid" }}>
    <Typography variant="subtitle1" fontWeight={600} color="text.primary">
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" mt={Spacing.XS}>
        {description}
      </Typography>
    )}
  </Box>
);
